import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-test-info-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlTestInfoApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlGetTestInfoApi"),
            description: this.translation.t("specs.controlGetTestInfoApiDescription"),

            httpMethod: "GET",
            path: "/controls/{controlId}/testing/advanced/effectiveness/automation/testinfo",

            parameters: [
                {
                    name: "controlId",
                    in: "path",
                    paramType: "integer",
                    required: true,
                    example: "1 | 2 | 3",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: {
                        controlId: "integer",
                        controlName: "string",
                        controlFrequency: "string",
                        testPeriods: [
                            {
                                testPeriodId: "uuid",
                                testPeriodName: "string",
                                testPeriodStart: "datetime",
                                testPeriodEnd: "datetime",
                                minimumNumberOfSamples: "integer",
                                testPlans: [
                                    {
                                        testPlanId: "uuid",
                                        testPlanName: "string",
                                        testPlanStart: "datetime",
                                        testPlanEnd: "datetime",
                                        status: "string",
                                        sampleMethod: "string",
                                        numberOfTestSamples: "integer",
                                        testPopulation: "integer",
                                        dueDateSourceDocumentUploader: "datetime",
                                        dueDateEvidenceUploader: "datetime",
                                        testSamples: [
                                            {
                                                testSampleId: "uuid",
                                                testSampleName: "string",
                                                testSteps: [
                                                    {
                                                        testStepId: "uuid",
                                                        testStepName: "string",
                                                        requiredDocuments: "string",
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                },
            ],
        };
    }
}
